import { ApiModel, ApiRelationship, ApiResource } from 'lib/interfaces/api';

export enum TransactionStatusState {
  Active = 'active',
  Inactive = 'inactive',
}

export enum DefaultTransactionStatus {
  Approved = 'approved',
  Created = 'created',
  Declined = 'declined',
  NeedsReview = 'needs_review',
}

export interface TransactionStatusAttributes {
  name: string;
  status: TransactionStatusState;
  'display-name': string;
  'deactivated-at': string;
  'created-at': string;
  'updated-at': string;
}

export interface TransactionStatusRelationships {
  'transaction-type': ApiRelationship<ApiModel.TransactionType>;
}

export type TransactionStatus = ApiResource<
  TransactionStatusAttributes,
  TransactionStatusRelationships,
  ApiModel.TransactionStatus
>;
